/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AbstractService, ServiceCallType } from '@iotize/tap';

export class BleService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get BLE MAC address
   *
   * LWM2M path: /1024//22
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getAddress(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getAddressCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//22
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getAddressCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAddress };

    return callOptions;
  }
}
